import * as variables from '../variables.js';

import "./site/Analytics";
import "./site/MarkTransformedPhoneNumbers";

import './index-previous';

import ViewportTracker from '../lib/ViewportTracker';
ViewportTracker.init(variables);

import AutoCompleter from "../component/AutoCompleter";
AutoCompleter();

import DynamicTooltipMaker from "./lib/DynamicTooltipMaker";
new DynamicTooltipMaker(
	".pageHeader, .text, .richContent__content, .childListingCard__content, .cardGroupItem__content, .listItem, .productIntro__main, .productTabs__contents, .person__content",
	"tooltipGlossary"
);

import ActOnForm from "./lib/ActOnForm";
ActOnForm.init();

import ProductFilters from '../component/ProductFilters';
new ProductFilters({
	form: '#filteredProductsForm',
	items: '.productFilter',
	styleClass: {
		active: 'isActive'
	}
});

import LaborCalculator from "../component/LaborCalculator";
new LaborCalculator();

import entryVideo from '../component/entryVideo';
entryVideo('.masthead__media');

// scrollDown Indicator
let scrollIndicator = document.querySelector('.masthead__scrollIndicator');
if (scrollIndicator) {
	scrollIndicator.addEventListener('click', function(event) {
		event.preventDefault();
		var selector = this.href.substring(this.href.indexOf('#') + 1);
		document.getElementById(selector).scrollIntoView();
	});
}

function videoQueryParamInit() {
	//@ts-ignore
	const params = (new URL(document.location)).searchParams;
	const video = params.get("video");
	if (video) {
		//@ts-ignore
		$.magnificPopup.open({
			items: {
				type: 'iframe',
				src: `//player.vimeo.com/video/${video}?autoplay=1&autopause=0`
			}
		});
	}
}
videoQueryParamInit();

import './site/vimeoThumbnails';

// document.addEventListener('DOMContentLoaded', () => {
if (document.querySelector('.courses')) {
	const createButton = (trigger:HTMLElement) => {
		const button = document.createElement('button');
		button.className = 'toggle-modal';
		button.setAttribute('aria-expanded', 'false');
		for (let node: typeof trigger.firstChild; (node = trigger.firstChild) !== null;) {
			button.appendChild(node);
		}
		trigger.appendChild(button);

		return button;
	};

	const openDialog = (content:HTMLElement) => {
		const dialog = document.createElement('dialog');
		dialog.innerHTML = `
			<form method="dialog">
				<button autofocus><span class="screen-reader-text">Close</span> <i class="icon"></i></button>
			</form>
		`;
		const clonedContent = content.cloneNode(true) as HTMLElement;
		clonedContent.hidden = false;
		dialog.classList.add('collegeLevelCourse');
		dialog.appendChild(clonedContent);
		dialog.addEventListener("close", () => {
			dialog.remove();
		});
		document.body.appendChild(dialog);
		dialog.showModal();
	};

	const setupEvents = (button:HTMLButtonElement, modalContent:HTMLElement) => {
		button.addEventListener('click', () => {
			openDialog(modalContent);
		});
	};
	const createContent = (item: Element) => {
		const modalContent: HTMLElement = item.querySelector('.course-content');
		const heading = item.querySelector<HTMLElement>('.course-heading');
		const clonedHeading = document.createElement('h2');
		clonedHeading.textContent = heading.textContent;
		modalContent.prepend(clonedHeading);
		return { modalContent, heading };
	};

	const initializeModal = () => {
		document.querySelectorAll('.courses > li').forEach(item => {
			const { modalContent, heading } = createContent(item);
			const button = createButton(heading);
			modalContent.hidden = true;
			setupEvents(button, modalContent);
		});
	};
	initializeModal();
};
// });
